import { Component, Inject, ViewEncapsulation, ElementRef } from "@angular/core";
import { MdSnackBar, MdDialogRef, MD_DIALOG_DATA } from "@angular/material";
import "rxjs/Rx";
import swal from "sweetalert2";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ProductReleaseStatus } from "../../interfaces/ProductReleaseStatusEnum.model";
import { ProductsWithPushNotification } from "../../interfaces/PushNotificationHistory";
import { ProductReleaseService } from "../../services/ProductReleaseService";
import { AppLoaderService } from "../../../services/app-loader/app-loader.service";

@Component({
    selector: 'activate-release',
    template: require('./activateRelease.component.html'),
    styles: [require('./activateRelease.component.css')],
    // encapsulation: ViewEncapsulation.None
})
export class ActivateReleaseComponent {
    releaseForm: FormGroup;
    Title: string = "Activate Release";
    TitleDescription: string;
    IsPushNotificationChecked: boolean = true;
    ProductReleaseStatus = ProductReleaseStatus;
    isPilotReleaseExists: boolean = false;
    isCustomReleaseExists: boolean = false;
    customersLoaded: boolean = false;
    customers: any[] = [];
    releaseTypes = [
        { label: 'Pilot', value: ProductReleaseStatus.PilotRelease },
        { label: 'Custom', value: ProductReleaseStatus.CustomRelease },
        { label: 'Prod', value: ProductReleaseStatus.ProductionRelease }
    ];  
    
    constructor(
        private fb: FormBuilder, 
        public dialogRef: MdDialogRef<ActivateReleaseComponent>,
        private elementRef: ElementRef,
        private appLoaderService: AppLoaderService,
        public snackBar: MdSnackBar,
        private productRelaseService: ProductReleaseService,        
        @Inject(MD_DIALOG_DATA) public data: any
    ) {}

    ngAfterViewInit() {
        const container = this.elementRef.nativeElement.closest('md-dialog-container');
        if (container) {
            container.style.overflow = 'visible';
        }
    }
    ngOnInit() {
        document.body.style.overflow="hidden";
        this.TitleDescription = `Are you sure you want to activate Release v${this.data.ProductReleaseNo} ?`;
        console.log(this.data)

        // Iterate the list of releases and check if any of them is a Pilot or Custom release.
        const releaseList = this.data.releaseList || [];
        this.isPilotReleaseExists = releaseList.some((release: any) => 
            this.getReleaseStatus(release) === ProductReleaseStatus.PilotRelease
        );
        
        this.isCustomReleaseExists = releaseList.some((release: any) =>  
            this.getReleaseStatus(release) === ProductReleaseStatus.CustomRelease
        );

        this.releaseForm = this.fb.group({
            releaseType: [null, Validators.required],
            comment: [null],
            customers: [null],
            isNotifySyncItClientAdmin: [null, [Validators.required]]
        });

        this.setupValidation();
    }

    getReleaseStatus(release: any) {
        return release.Status !== undefined ? release.Status : release.ReleaseType;
    }

    isReleaseTypeDisabled(releaseType: ProductReleaseStatus) {
        return (releaseType === ProductReleaseStatus.PilotRelease && this.isPilotReleaseExists) ||
            (releaseType === ProductReleaseStatus.CustomRelease && this.isCustomReleaseExists);
    }
    
    setupValidation() {
        this.releaseForm.get('releaseType').valueChanges.subscribe(value => {
            const comment = this.releaseForm.get('comment');
            const releaseType = this.releaseForm.get('releaseType');
            const customers = this.releaseForm.get('customers');

            if (value === ProductReleaseStatus.ProductionRelease) {
                releaseType.clearValidators();
                comment.clearValidators();
                customers.clearValidators();
            } else {
                releaseType.setValidators([Validators.required]);
                comment.setValidators([Validators.required, Validators.pattern('.*\\S.*')]);
                customers.setValidators([Validators.required]);
            }

            comment.updateValueAndValidity();
            customers.updateValueAndValidity();

            if ((value === ProductReleaseStatus.PilotRelease || value === ProductReleaseStatus.CustomRelease) && !this.customersLoaded) {
                this.loadCustomers();
            }
        });
    }

    isProdReleaseWarningDisplay(){
        return this.releaseForm.get('releaseType').value == ProductReleaseStatus.ProductionRelease;
    }
    
    private loadCustomers(): void {
        this.appLoaderService.open();
        this.productRelaseService.getCustomers(this.data.ProductId).subscribe(
            (data: any) => {
                if(!data.IsError && data.DataObject != null){
                    this.customers = data.DataObject.Customers;
                    this.customersLoaded = true;
                }
                                
                this.appLoaderService.close();
            },
            (error) => {
                console.error(error);
                this.appLoaderService.close();
            }
        );
    }
    checkIsValidProductForNotification() {
        let productCode = this.data.ProductCode;
        if (productCode in ProductsWithPushNotification) {
          return true;
        }
        return false;
    }
    
    activateRelease() {
        console.log(this.releaseForm.value);
        const selectedReleaseType = this.releaseForm.value.releaseType;
        const releaseTypeName = selectedReleaseType === ProductReleaseStatus.ProductionRelease ? "Prod" : (this.releaseForm.value.releaseType === ProductReleaseStatus.PilotRelease ? "Pilot" : "Custom");
        console.log("Selected Release Type: ", selectedReleaseType);
        this.appLoaderService.open();
    
        let model = {
            ProductId: Number(this.data.ProductId),
            ProductReleaseId: this.data.ProductReleaseId,
            ReleaseStatus: this.releaseForm.value.releaseType,
            UpdatedBy: Number(localStorage.getItem("userid")),
            Comment: this.releaseForm.value.comment,
            CustomerIds: this.releaseForm.value.customers,
        };

        this.productRelaseService.ActivateRelease(model).subscribe(
            (data) => {
                if(!data.IsError && data.DataObject != null){
                    let releaseStatusChangeMessage =`Release status changed to ${releaseTypeName} Successfully`;
                    this.dialogRef.close({
                        SelectedReleaseType: this.releaseForm.value.releaseType,
                        customers: this.releaseForm.value.customers,
                        isNotifySyncItClientAdmin: this.releaseForm.value.isNotifySyncItClientAdmin
                    });
                    this.snackBar.open(releaseStatusChangeMessage, "", {
                        duration: 2000,
                    });
                }
                else{
                    this.dialogRef.close(false);
                    this.snackBar.open(data.Error, "", {
                        duration: 2000,
                    });
                }
                document.body.style.overflow="auto";
            },
            (error) => {
                document.body.style.overflow="auto";
                this.dialogRef.close(false);
            }
        );
    }

    STPStart(showLoadder: boolean = true, ISRequestSTP = false) {
        if (showLoadder) this.appLoaderService.open();

        let model = {
            ProductReleaseId: this.data.ProductReleaseId,
            IsApproved: true,
            UpdatedBy: Number(localStorage.getItem("userid")),
        };

        this.productRelaseService.STPStart(model).subscribe(
            (data) => {
                if (!data.IsError && data.DataObject != null) {
                    this.snackBar.open("STP Started", "", {
                        duration: 2000,
                    });
                } else {
                    this.snackBar.open(data.Error, "", {
                        duration: 2000,
                    });
                }

                let result = {
                    SelectedReleaseType: ProductReleaseStatus.STPStart,
                }
                document.body.style.overflow="auto";
                this.dialogRef.close(result);
            },
            (_error) => {
                document.body.style.overflow="auto";
                this.dialogRef.close(false);
                this.appLoaderService.close();
            }
        );
    }

    onSubmit() {
        if (!this.data.IsSTPPerformed) {
                swal
                  .fire({
                    title: "<strong>Releasing Product without STP</strong>",
                    icon: "info",
                    html: `
                <p><b>Warning:</b> Releasing this product without testing carries significant risks and could lead to unexpected behavior, performance issues, or even security vulnerabilities. By proceeding, you acknowledge and accept these risks.</p>
                <b>Please confirm your action:</b>
                <ul style="text-align: left;">
                <li style="margin-top:10px;"><b>Accept:</b> Proceed with releasing this product without STP.</li>
                <li><b>Request STP:</b> Requesting QA Department to perform STP.</li>
                <li><b>Cancel:</b> Effectively closes this dialog box without applying any alterations.</li>
                </ul>
                `,
                    showCloseButton: true,
                    showCancelButton: true,
                    showDenyButton: true,
                    focusConfirm: false,
                    confirmButtonText: `Accept`,
                    confirmButtonAriaLabel: "Accept",
                    cancelButtonText: `Cancel`,
                    cancelButtonAriaLabel: "Cancel",
                    denyButtonText: `Request STP`,
                    denyButtonAriaLabel: "Request STP",
                  })
                  .then((result) => {
                    if (result.isConfirmed) {
                      this.activateRelease();
                    }
                    else if (result.isDenied) {
                      this.appLoaderService.open();
                      this.productRelaseService
                        .getReleaseByProductId(this.data.ProductId)
                        .subscribe(
                          (data) => {
                            let IsAllowRelease: boolean = true;
                            if (!data.IsError && data.DataObject != null) {
                              
                              let releaseData = data.DataObject;
                              releaseData.forEach((element) => {
                                if (
                                  (element.Status == 0 || element.Status == 1) &&
                                  element.IsDeleted == false
                                ) {
                                  IsAllowRelease = false;
                                }
                              });
                              if (IsAllowRelease == true) {
                                this.STPStart(false, true);
                              } else {
                                this.appLoaderService.close();
                                swal
                                  .fire({
                                    title: "<strong>Unable To Process Request</strong>",
                                    icon: "info",
                                    html: `<P>You can't request STP because there is already one pending release in queue</P>`,
                                    showDenyButton: false,
                                    showCancelButton: false,
                                    confirmButtonText: "Ok",
                                  })
                                  .then((result) => {
                                    /* Read more about isConfirmed, isDenied below */
                                    if (result.isConfirmed) {
                                      this.onSubmit();
                                    }
                                  });
                              }
                            } else {
                              this.appLoaderService.close();
                            }
                          },
                          (error) => {
                            this.appLoaderService.close();
                          }
                        );
                    }
                  });
              } else {
                this.activateRelease();
              }
    }

    onCancel() {
        document.body.style.overflow="auto";
        this.dialogRef.close(false);
    }
    
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/page-layouts/activate-release/activateRelease.component.ts